const MAX_ANSWERS_LENGTH = 20;

export default {
  MAX_ANSWERS_LENGTH,
};
